import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 sm:py-12 px-3 xs:px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          <div className="col-span-2 sm:col-span-2 md:col-span-1 mb-2 sm:mb-0">
            <div className="flex items-center space-x-2 mb-2 sm:mb-4">
              <img src="/appointigo.png" alt="Appointigo" className="h-8 w-auto object-contain brightness-0 invert" />
            </div>
            <p className="text-sm sm:text-base text-gray-400">
              Smart scheduling platform for modern businesses and professionals.
            </p>
          </div>
          <div>
            <h2 className="text-sm sm:text-base font-semibold mb-2 sm:mb-4">Services</h2>
            <ul className="space-y-0.5 sm:space-y-1 text-xs sm:text-sm text-gray-400">
              <li>
                <Link to="/providers?category=healthcare" className="hover:text-white inline-block py-1.5">Healthcare</Link>
              </li>
              <li>
                <Link to="/providers?category=salon" className="hover:text-white inline-block py-1.5">Salon &amp; Spa</Link>
              </li>
              <li>
                <Link to="/providers?category=home-services" className="hover:text-white inline-block py-1.5">Home Services</Link>
              </li>
              <li>
                <Link to="/providers?category=fitness" className="hover:text-white inline-block py-1.5">Fitness</Link>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="text-sm sm:text-base font-semibold mb-2 sm:mb-4">Company</h2>
            <ul className="space-y-0.5 sm:space-y-1 text-xs sm:text-sm text-gray-400">
              <li>
                <Link to="/about" className="hover:text-white inline-block py-1.5">About Us</Link>
              </li>
              <li>
                <span className="hover:text-white cursor-default inline-block py-1.5">Careers</span>
              </li>
              <li>
                <Link to="/contact-us" className="hover:text-white inline-block py-1.5">Contact Us</Link>
              </li>
              <li>
                <span className="hover:text-white cursor-default inline-block py-1.5">Blog</span>
              </li>
            </ul>
          </div>
          <div className="col-span-2 sm:col-span-1">
            <h2 className="text-sm sm:text-base font-semibold mb-2 sm:mb-4">Policies</h2>
            <ul className="space-y-0.5 sm:space-y-1 text-xs sm:text-sm text-gray-400">
              <li>
                <Link to="/faq" className="hover:text-white inline-block py-1.5">FAQ</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="hover:text-white inline-block py-1.5">Terms &amp; Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-white inline-block py-1.5">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/shipping-policy" className="hover:text-white inline-block py-1.5">Shipping Policy</Link>
              </li>
              <li>
                <Link to="/cancellation-and-refund-policy" className="hover:text-white inline-block py-1.5">Cancellation &amp; Refunds</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 sm:pt-8 text-center text-xs sm:text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Appointigo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
